import { useEffect, useState, useCallback } from 'react';

import { initChatbotParams, sendMessageToChatbot } from './iframeMessageHandler';
import { useStore } from '../../zustand/stores';
import { CopilotDisplayMode } from '../../zustand/stores/copilot';

interface UseChatbotMessageSenderProps {
  onMessageSend?: (message: string) => void;
}

interface UseChatbotMessageSenderReturn {
  sendMessage: (message: string, forceReferral?: string) => void;
}

export const useChatbotMessageSender = ({
  onMessageSend,
}: UseChatbotMessageSenderProps): UseChatbotMessageSenderReturn => {
  const [pendingMessage, setPendingMessage] = useState<string | null>(null);

  const {
    isChatbotReady,
    setIsChatbotInitializing,
    setCopilotDisplayMode,
    setIsChatbotReady,
    chatbotReferral
  } = useStore(state => state.copilotSlice);
  const { selectedSite } = useStore(state => state.siteSelectorSlice);

  const sendMessage = useCallback((message: string, forceReferral?: string) => {
    const trimmedMessage = message.trim();
    if (!trimmedMessage) {
      return;
    }

    if (isChatbotReady) {
      initChatbotParams(
        window?.location.href,
        forceReferral ?? chatbotReferral as string,
        undefined,
        selectedSite?.metaSiteId,
      );
      sendMessageToChatbot(trimmedMessage);
      onMessageSend?.(trimmedMessage);
      setCopilotDisplayMode(CopilotDisplayMode.Chatbot);
    } else {
      setPendingMessage(trimmedMessage);
      setIsChatbotInitializing(true);
    }
  }, [isChatbotReady, onMessageSend, setIsChatbotInitializing, setCopilotDisplayMode, chatbotReferral, selectedSite]);

  useEffect(() => {
    if (isChatbotReady && pendingMessage) {
      sendMessageToChatbot(pendingMessage);
      onMessageSend?.(pendingMessage);
      setPendingMessage(null);
      setCopilotDisplayMode(CopilotDisplayMode.Chatbot);
    }
  }, [isChatbotReady, pendingMessage, onMessageSend, setIsChatbotInitializing, setIsChatbotReady]);
  return {
    sendMessage
  };
};
